import { AbstractControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

const today = new Date();
today.setHours(0, 0, 0, 0); // Rimuovo il tempo dall'oggetto Date per confrontare solo le date

const startDate = new Date(today.setDate(today.getDate() + 30));
const filter = new Date(today.setDate(today.getDate() - 1));

const filterDate = (d: Date | null): boolean => {
    return d !== null && d > filter;
};

export const RichiestaCommercioStep: FormlyFieldConfig[] = [
    {
        fieldGroupClassName: 'grid sm:grid-cols-1 md:grid-cols-3 gap-4',
        fieldGroup: [
            {
                key: 'jd.tipo_occupazione',
                type:'mat-select',
                props: {
                    label: 'TIPO OCCUPAZIONE',
                    required: true,
                    options: [
                        {
                            value: 'permanente',
                            label: 'OCCUPAZIONE PERMANENTE',
                        },
                        {
                            value: 'temporanea',
                            label: 'OCCUPAZIONE TEMPORANEA',
                        },
                    ],
                },
            },
            {
                key: 'jd.autorizzata_dal',
                type: '#data',
                props: {
                    label: 'DATA INIZIO',
                    description:"La validità dell'autorizzazione decorrerà dalla data di firma del titolo",
                    datepickerOptions: {
                        startAt: startDate,
                        filter: filterDate,
                        //min:startDate
                    },
                },
                validators: {
                    datemin: {
                        expression: (c: AbstractControl) =>
                            new Date(c.value) >= startDate,
                        message: (error: any, field: FormlyFieldConfig) =>
                            `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                    }
                },
                expressions:{
                    hide:"model.jd.tipo_occupazione != 'permanente'"
                }
            },
            {
                key: 'jd.tipologia_attivita_opt',
                type:'mat-select',
                props: {
                    label: 'TIPO DI ATTIVITÀ',
                    required: true,
                    options: [
                        { value: 1, label: 'PUBBLICO ESERCIZIO (no dehor)' },
                        { value: 2, label: 'Commercio' },
                        { value: 3, label: 'Artigiano' },
                        { value: 4, label: 'Altra attività (no dehor)' },
                    ],
                    change: (field) =>
                        field.parent
                            .get(`${field.key}_value`)
                            .formControl.setValue(
                                (
                                    field.props.options as Array<{
                                        value: any;
                                        label: string;
                                    }>
                                ).filter(
                                    (x) => x.value == field.formControl.value,
                                )[0].label,
                            ),
                },
            },

            {
                key: 'jd.tipologia_attivita_opt_value',
            },
        ],
    },

    {
        fieldGroup: [
            {
                key: 'jd.periodo_occupazione',
                type: 'repeat',
                defaultValue: [],
                props: {
                    addText: '+ AGGIUNGI PERIODO OCCUPAZIONE',
                    label: 'PERIODI DI OCCUPAZIONE *',
                    required: true,
                },
                wrappers: ['group-panel'],
                fieldArray: {
                    fieldGroupClassName:
                        'border border-t-4 p-4 pt-6 shadow-sm rounded-xl grid grid-flow-row-dense mb-2 sm:grid-cols-1 md:grid-cols-4 gap-4',
                    fieldGroup: [
                        {
                            className: 'sm:col-span-1 md:col-span-1',
                            key: 'data_inizio',
                            type: '#data',
                            props: {
                                label: 'DATA INIZIO',
                                datepickerOptions: {
                                    startAt: startDate,
                                    filter: filterDate,
                                },
                            },
                            validators: {
                                datemin: {
                                    expression: (c: AbstractControl) =>
                                        new Date(c.value) >= startDate,
                                    message: (
                                        error: any,
                                        field: FormlyFieldConfig,
                                    ) =>
                                        `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                                },
                            },
                        },
                        {
                            className: 'sm:col-span-1 md:col-span-1',
                            key: 'data_fine',
                            type: '#data',
                            props: {
                                label: 'DATA FINE',
                                datepickerOptions: {
                                    startAt: startDate,
                                    filter: filterDate,
                                },
                            },
                            validators: {
                                datemin: {
                                    expression: (c: AbstractControl) =>
                                        new Date(c.value) >= startDate,
                                    message: (
                                        error: any,
                                        field: FormlyFieldConfig,
                                    ) =>
                                        `Inserisci una data successiva al ${startDate.toLocaleDateString()}`,
                                },
                            },
                        },
                    ],
                    validators: {
                        validation: [{ name: 'dateRangeValidator', options: { start:'data_inizio', end:'data_fine', errorPath: 'data_fine', message: 'La data di fine deve essere successiva alla data di inizio' } }],
                    },
                },
                validation :{
                    messages: {
                        required : 'Campo obbligatorio: inserisci almeno un periodo di occupazione'
                    }
                }
            },
        ],
        expressions: {
            hide: "model.jd.tipo_occupazione != 'temporanea'",
        },
    },
    {
        key: 'jd.tipologia_attivita',
        type:'mat-textarea',
        props: {
            label: 'DESCRIZIONE ATTIVITÀ',
            required: true,
            autosize: true,
            autosizeMaxRows: 8,
            autosizeMinRows: 2,
        },
        validation: {
            show: true,
        },
        wrappers: ['form-field'],
        expressions: {
            type: "formState.editMode? 'textarea' : 'input-read'"
        }

    },
    {
        key: 'jd.autorizzazione_commercio_opt',
        type:'mat-checkbox',
        defaultValue: false,
        props: {
            label: "L'ATTIVITÀ NON PREVEDE AUTORIZZAZIONE O COMUNICAZIONE ALL'UFFICIO ATTIVITÀ PRODUTTIVE",
            indeterminate: false,
            color: 'primary',
        },
    },
    {
        fieldGroupClassName:
            'grid grid-flow-row-dense sm:grid-cols-1 md:grid-cols-2 gap-4',
        fieldGroup: [
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.numero_autorizzazione_scia',
                type:'mat-input',
                props: {
                    label: 'NUM. AUTORIZZAZIONE / NUM. PROT SCIA ATTIVITÀ PRODUTTIVE',
                    required: true,
                },
            },
            {
                className: 'sm:col-span-1 md:col-span-1',
                key: 'jd.data_autorizzazione_scia',
                "type": "#data",
                "props": {
                    "label": 'DATA DI RILASCIO',
                    "datepickerOptions": {
                        "startAt": startDate,
                    },
                },
            },
        ],
        expressions: {
            hide: 'model.jd.autorizzazione_commercio_opt',
        },
    },
];
